import { useTranslation } from 'react-i18next';

const trustItems = [
  {
    icon: 'ri-refresh-line',
    key: '1',
    image:
      'https://readdy.ai/api/search-image?query=Soft%20abstract%20still%20life%20of%20a%20small%20open%20notebook%20with%20a%20pencil%20and%20a%20few%20fresh%20green%20leaves%20on%20a%20bright%20airy%20white%20surface%2C%20symbolizing%20fresh%20updates%20and%20renewal%2C%20gentle%20natural%20light%2C%20clean%20minimal%20aesthetic%2C%20high%20detail&width=600&height=400&seq=trust-updated&orientation=landscape',
  },
  {
    icon: 'ri-layout-grid-line',
    key: '2',
    image:
      'https://readdy.ai/api/search-image?query=Neatly%20arranged%20grid%20of%20pastel%20colored%20sticky%20notes%20and%20small%20index%20cards%20organized%20in%20clean%20rows%20on%20a%20soft%20light%20surface%2C%20representing%20clarity%20and%20organization%2C%20soft%20diffused%20lighting%2C%20minimal%20flat%20lay%2C%20high%20detail&width=600&height=400&seq=trust-clear&orientation=landscape',
  },
  {
    icon: 'ri-shield-check-line',
    key: '3',
    image:
      'https://readdy.ai/api/search-image?query=Minimal%20flat%20illustration%20style%20photo%20of%20a%20soft%20green%20shield%20symbol%20resting%20on%20a%20clean%20light%20background%20with%20a%20subtle%20padlock%20detail%2C%20symbolizing%20security%20and%20protection%2C%20soft%20diffused%20light%2C%20calm%20minimal%20aesthetic%2C%20high%20detail&width=600&height=400&seq=trust-safety&orientation=landscape',
  },
  {
    icon: 'ri-compass-3-line',
    key: '4',
    image:
      'https://readdy.ai/api/search-image?query=Minimal%20still%20life%20of%20a%20small%20brass%20compass%20and%20a%20folded%20roadmap%20on%20a%20warm%20cream%20linen%20surface%2C%20symbolizing%20independent%20guidance%20and%20navigation%2C%20soft%20directional%20light%2C%20editorial%20minimal%20composition%2C%20high%20detail&width=600&height=400&seq=trust-independent&orientation=landscape',
  },
];

export default function TrustBar() {
  const { t } = useTranslation();

  return (
    <section className="border-y border-stone-200/70 bg-white">
      <div className="mx-auto max-w-7xl px-4 py-8 md:px-6">
        <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-4">
          {trustItems.map((item) => (
            <div key={item.key} className="overflow-hidden rounded-lg border border-stone-200 bg-white">
              <div className="aspect-[3/2] w-full overflow-hidden">
                <img
                  src={item.image}
                  alt={t(`trust.item${item.key}Title`)}
                  title={t(`trust.item${item.key}Title`)}
                  className="h-full w-full object-cover object-top"
                />
              </div>
              <div className="flex items-start gap-3 p-4">
                <span className="flex h-9 w-9 flex-shrink-0 items-center justify-center rounded-lg bg-emerald-100 text-emerald-700">
                  <i className={`${item.icon} w-5 h-5 flex items-center justify-center`} aria-hidden="true" />
                </span>
                <div>
                  <h3 className="text-sm font-semibold text-stone-900">{t(`trust.item${item.key}Title`)}</h3>
                  <p className="mt-1 text-xs leading-relaxed text-stone-500">{t(`trust.item${item.key}Desc`)}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}